import { Component, Input, OnInit } from '@angular/core';
import { ClosedModalError } from 'src/app/core/errors';
import { AlertItem, AlertType, ComponentModal, MessageModal, User } from 'src/app/core/models';
import { AlertService, ModalService } from 'src/app/core/services';
import { UserSelectModalComponent } from '../user-select-modal/user-select-modal.component';
import { AdministrativeService } from 'src/app/core/services/administrative.service';

export const AdminPermissionI18n = {
  CreateContract: 'Criar Contrato',
  ViewContract: 'Visualizar Contrato',
  UpdateContract: 'Editar Contrato',
  DeleteContract: 'Deletar Contrato',
  CreateAppraisal: 'Criar Aferição',
  ViewAppraisal: 'Visualizar Aferição',
  UpdateAppraisal: 'Editar Aferição',
  DeleteAppraisal: 'Deletar Aferição',
  CreateCompany: 'Criar Empresa',
  ViewCompany: 'Visualizar Empresa',
  UpdateCompany: 'Editar Empresa',
  DeleteCompany: 'Deletar Empresa',
};

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.sass']
})
export class PermissionsComponent implements OnInit {

  @Input() permissions = [];
  public loading = false;
  public adminPermissions: Array<{ id: number; name: string; users: User[] }> = [];
  public adminPermissionsPaginated: Array<{ id: number; name: string; users: User[] }> = [];
  public permissionI18n = AdminPermissionI18n;

  constructor(
    private modalService: ModalService,
    private alertService: AlertService,
    public administrativeService: AdministrativeService
  ) { }

  async ngOnInit() {
    await this.getAdminPermissions();
  }

  async getAdminPermissions() {
    this.loading = true;
    const response = await this.administrativeService.listAdminPermissions();
    this.adminPermissions = response;
    this.adminPermissions.forEach(adminPermission => {
      const users = this.permissions.find(a => a.content.permissionId === adminPermission.id);
      if (users !== undefined) {
        adminPermission.users = users.content.users;
      }
    });
    this.loading = false;
  }

  setAdminPermissionsPaginated(event) {
    if (event !== this.adminPermissionsPaginated) {
      this.adminPermissionsPaginated = event;
    }
  }

  async openDeleteModalUser(user, permission) {
    let success = false;
    try {
      const resultModal = await this.modalService.show(new MessageModal(
        `Remover permissão ${this.permissionI18n[permission.name]}`,
        `Deseja remover a permissão ${this.permissionI18n[permission.name]} do usuário ${user.name} ?`, true
      ));
      this.loading = true;
      const relationId = user.relationId;
      await this.administrativeService.removeRelationUserAdminPermission(relationId);
      success = true;
    } catch (error) {
      if (error instanceof ClosedModalError) {
        const modalError = error as ClosedModalError;
        console.error(modalError);
        this.alertService.show(new AlertItem('GenericError', AlertType.danger));
      }
    } finally {
      if (success) {
        this.alertService.show(new AlertItem('AdminPermissionRemoved', AlertType.success));
      }
      setTimeout(() => {
        location.reload();
      }, 2000);
    }
  }

  openDetail(data) { }

  async addUsers(permissionId: number) {
    try {
      const result = await this.modalService.show(new ComponentModal(UserSelectModalComponent, {
        permissionId
      }));
      this.loading = true;
      setTimeout(() => {
        location.reload();
      }, 2000);
    } catch (err) {
      if (err instanceof ClosedModalError) {
        const modalError = err as ClosedModalError;
      }
    }
  }

}
